"use client";
import { useEffect, useState } from "react";
import TimerClock from "./TimerClock";

const EarlyBird = () => {
  const [showBanner, setShowBanner] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowBanner(false);
      } else {
        setShowBanner(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div
      className={`w-full hidden md:flex bg-[#222222] py-[16px] px-[16px] justify-center fixed top-0 z-10 transition-transform duration-300 ${
        showBanner ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="flex flex-col md:flex-row justify-center items-center w-full gap-4">
        <p className="text-[24px] md:text-[21px] text-white font-[600] text-center">
          Free 7 days trial to top 10 users, be a part of expert guidance!
        </p>
        <TimerClock endTime="2025-06-25T23:00:00" />
        <button className="w-full sm:w-auto px-2 py-1 rounded-[4px] flex justify-center sm:justify-start items-center gap-2 bg-[#007aff] text-white font-[600] hover:bg-[#006fe8]">
          Early Bird
        </button>
      </div>
    </div>
  );
};

export default EarlyBird;
